module.exports = __webpack_public_path__ + "img/bg_philosophy.7b7b6968.png";